<template>
  <div class="basis-full md:basis-1/2">
    <div class="mb-4 flex items-baseline">
      <div class="basis-1/12">
        <p class="co-display-9 font-bold text-co-danger-500">
          Q
        </p>
      </div>
      <div class="basis-11/12">
        <h3 class="co-display-10 font-bold">
          <slot name="question">
            参加に迷っているのですが…
          </slot>
        </h3>
      </div>
    </div>
    <div class="flex">
      <div class="basis-1/12">
        <p class="co-display-9 font-bold text-co-info-500">
          A
        </p>
      </div>
      <div class="basis-11/12">
        <slot name="answer">
          <p class="mb-4">
            テックアカデミーへの参加を検討されている方向けに、無料でプロのカウンセラーに相談できる無料相談もご用意しています。お気軽にご参加ください。
          </p>
          <a
            class="bot_open"
            href="/counseling/htmlcss-schedule"
          >無料相談の詳細はこちら</a>
        </slot>
      </div>
    </div>
  </div>
</template>
